import { CustomToastComponent } from "@/components/shared";
import { LoginUserResponse, Role, LoginUserDocument, LoginUserQueryVariables, LoginUserQuery } from "@/graphql/__generated__/graphql";
import { login } from "@/utils/authentication";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useLoginUserLazyQueryHook = (forwardPath?: string | null) => {

  // Hooks
  const { t } = useTranslation(["toasts"]);
  const navigate = useNavigate();


  const [ loginUser, { data, loading, error }] = useLazyQuery<LoginUserQuery, LoginUserQueryVariables>(
    LoginUserDocument, {
      fetchPolicy: "cache-first"
    });

  useEffect(() => {
    if (data) {
      login(data.loginUser as LoginUserResponse);

      // Navigate to forward path if provided, otherwise use default navigation
      if (forwardPath) {
        navigate(forwardPath, { replace: true });
      } else {
        if (data.loginUser?.user?.role === Role.Admin) {
          navigate("/admin");
        } else {
          navigate("/dashboard");
        }
      }

      toast(CustomToastComponent, {
        toastId: "login-success",
        data: {
          title: t("toasts.loginsuccess.title"),
          type: "success",
        }
      });
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      navigate("/login", { replace: true });
    }
  }, [error]);

  return {
    loginUser,
    loading,
    error
  };
};
